<template>
  <v-slide-y-transition mode="out-in">
    <v-container fluid class="pa-3">
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-toolbar dense prominent>
              <v-toolbar-title>Timesheet Listing (HOD)</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn small fab v-on="on">
                    <v-icon>
                      filter_list
                    </v-icon>
                  </v-btn>
                </template>
                <span>Filter list</span>
              </v-tooltip> -->

              <v-toolbar-items>
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small fab @click="addNewRecord_onClick()" v-on="on">
                      <v-icon>
                        add_circle_outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Add new</span>
                </v-tooltip> -->
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pa-0">
              <v-container>
                <v-layout row wrap>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div class="subheading">
                          Filter Panel
                        </div>
                      </template>

                      <v-btn color="green" @click="refresh_table()"
                        >Generate Now</v-btn
                      >

                      <FilterEditor
                        :query.sync="new_filter"
                        :rules="get_filterable_columns"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table
                      id="report_table"
                      ref="attendance_report"
                      :headers="table_setting.headers"
                      :items="table_setting.records"
                      :loading="table_setting.loading"
                      must-sort
                      :pagination.sync="table_setting.pagination"
                      :rows-per-page-items="table_setting.rows_per_page_items"
                      :total-items="table_setting.pagination.totalItems"
                      class="elevation-1"
                    >
                      <v-progress-linear
                        v-slot:progress
                        color="blue"
                        indeterminate
                      ></v-progress-linear>
                      <template v-slot:items="props">
                        <tr
                          v-bind:class="{
                            'blue lighten-5':
                              get_date_day(props.item.date) == 'Sat',
                            'orange lighten-4':
                              get_date_day(props.item.date) == 'Sun'
                          }"
                        >
                          <td class="pa-1 pl-3">{{ props.item.id }}</td>
                          <td class="pa-1">{{ props.item.emp__full_name }}</td>
                          <td class="pa-1">
                            {{ get_date_day(props.item.date) }}
                          </td>
                          <td class="pa-1">{{ props.item.date }}</td>
                          <td class="pa-1">
                            {{ get_epoch_time_v2(props.item, "time_on") }}
                          </td>
                          <td class="pa-1">
                            {{
                              get_epoch_time_v2(props.item, "time_lunch_out")
                            }}
                          </td>
                          <td class="pa-1">
                            {{ get_epoch_time_v2(props.item, "time_lunch_in") }}
                          </td>
                          <td class="pa-1">
                            {{ get_epoch_time_v2(props.item, "time_off") }}
                          </td>
                          <td class="pa-1">
                            {{ get_actual(props.item.actual) }}
                          </td>
                          <td class="pa-1">
                            {{ get_epoch_minutes(props.item.lateness) }}
                          </td>
                          <td class="pa-1">
                            {{ get_epoch_minutes(props.item.lunch_lateness) }}
                          </td>
                          <td class="pa-1">
                            {{ get_epoch_minutes(props.item.early) }}
                          </td>
                          <td class="pa-1">{{ props.item.ot }}</td>
                          <td class="pa-1">{{ props.item.other__value }}</td>
                          <td class="pa-1">{{ props.item.other_hour }}</td>
                          <td class="pa-1">{{ props.item.remark }}</td>
                          <td class="pa-1">{{ props.item.status__value }}</td>
                          <td class="justify-center layout px-0">
                            <v-icon
                              small
                              class="mr-2"
                              color="orange"
                              @click="edit_attendance_rec(props.item)"
                            >
                              edit
                            </v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <v-dialog
                      v-model="dialog.show"
                      max-width="550px"
                      persistent
                    >
                      <v-card>
                        <v-card-title>
                          <span class="headline">Update Attendance Record</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs2>
                                <v-text-field
                                  label="ID#"
                                  :value="dialog.selected.id"
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4>
                                <v-text-field
                                  label="Date(Day)"
                                  :value="
                                    ` ${dialog.selected.date}(${get_date_day(
                                      dialog.selected.date
                                    )})`
                                  "
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field
                                  label="Full Name"
                                  :value="dialog.selected.emp__full_name"
                                  readonly
                                ></v-text-field>
                              </v-flex>

                              <v-flex xs3>
                                <v-text-field
                                  @click="update_epoch('On Duty', 'time_on')"
                                  label="On Duty"
                                  :value="
                                    get_epoch_time(dialog.selected.time_on)
                                  "
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <v-text-field
                                  @click="
                                    update_epoch('Out Lunch', 'time_lunch_out')
                                  "
                                  label="Out For Lunch"
                                  :value="
                                    get_epoch_time(
                                      dialog.selected.time_lunch_out
                                    )
                                  "
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <v-text-field
                                  @click="
                                    update_epoch('Out Lunch', 'time_lunch_in')
                                  "
                                  label="In From Lunch"
                                  :value="
                                    get_epoch_time(
                                      dialog.selected.time_lunch_in
                                    )
                                  "
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <v-text-field
                                  @click="update_epoch('Out Lunch', 'time_off')"
                                  label="Off Duty"
                                  :value="
                                    get_epoch_time(dialog.selected.time_off)
                                  "
                                  readonly
                                ></v-text-field>
                              </v-flex>

                              <v-flex xs2>
                                <v-text-field
                                  label="OT"
                                  v-model.number="dialog.selected.ot"
                                  mask="####"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs8>
                                <v-select
                                  :items="dialog.other_categories"
                                  item-value="id"
                                  item-text="value"
                                  clearable
                                  v-model="dialog.selected.other_id"
                                  label="Other Category"
                                ></v-select>
                              </v-flex>
                              <v-flex xs2>
                                <v-text-field
                                  label="O Total"
                                  mask="####"
                                  v-model.number="dialog.selected.other_hour"
                                ></v-text-field>
                              </v-flex>

                              <v-flex xs12>
                                <v-textarea
                                  name="remark"
                                  box
                                  label="Remark"
                                  v-model="dialog.selected.remark"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="orange"
                            flat
                            @click="dialog.show = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="green darken-1"
                            flat
                            @click="save_attendance_rec()"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="dialog.time_dialog.show"
                      persistent
                      max-width="450px"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="headline"
                            >Update {{ dialog.time_dialog.title }}</span
                          >
                        </v-card-title>

                        <v-card-text>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 class="text-xs-center">
                                <v-time-picker
                                  ref="time_picker"
                                  use-seconds
                                  v-model="dialog.time_dialog.time"
                                  format="24hr"
                                ></v-time-picker>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="orange"
                            flat
                            @click="dialog.time_dialog.show = false"
                            >Cancel</v-btn
                          >

                          <v-btn
                            color="green"
                            flat
                            @click="confirm_update_epoch()"
                            >Confirm</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
import common from "../../functions/general";
import qb from "../../functions/query.builder";
import FilterEditor from "../../components/FilterEditor";

const day_setting = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default {
  name: "TimesheetListing",
  components: {
    FilterEditor: FilterEditor
  },
  data() {
    return {
      new_filter: {
        condition: "and",
        rules: []
      },
      filter_options: [],
      dialog: {
        show: false,
        other_categories: [],
        selected: {},
        time_dialog: {
          show: false,
          title: "",
          time: "",
          ref_name: ""
        }
      },
      table_setting: {
        loading: false,
        rows_per_page_items: [
          20,
          40,
          70,
          100,
          200,
          500,
          1000,
          1500,
          2000,
          2500,
          3000
        ],
        headers: [
          {
            text: "ID#",
            value: "id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Name",
            align: "left",
            class: "pa-1",
            value: "emp__full_name",
            filterable: true,
            data_type: String
          },
          {
            text: "Day",
            value: "dk",
            class: "pa-1",
            sortable: false,
            filterable: false,
            data_type: String
          },
          {
            text: "Date",
            class: "pa-1",
            value: "date",
            filterable: true,
            data_type: Number
          },
          {
            text: "On Duty(08:40)",
            align: "left",
            class: "pa-1",
            value: "time_on",
            filterable: false,
            data_type: String
          },
          {
            text: "Out Lunch",
            align: "left",
            class: "pa-1",
            value: "time_lunch_out",
            filterable: false,
            data_type: String
          },
          {
            text: "In Lunch",
            class: "pa-1",
            value: "time_lunch_in",
            filterable: false,
            data_type: String
          },
          {
            text: "Off Duty",
            class: "pa-1",
            value: "time_off",
            filterable: false,
            data_type: String
          },
          {
            text: "Total(m)",
            class: "pa-1",
            value: "actual",
            filterable: true,
            data_type: Number
          },
          {
            text: "Late(m)",
            class: "pa-1",
            value: "lateness",
            filterable: true,
            data_type: Number
          },
          {
            text: "Lunch(m)",
            class: "pa-1",
            value: "lunch_lateness",
            filterable: true,
            data_type: Number
          },
          {
            text: "Leave Early(m)",
            class: "pa-1",
            value: "early",
            filterable: true,
            data_type: Number
          },
          {
            text: "OT(m)",
            class: "pa-1",
            value: "ot",
            filterable: true,
            data_type: Number
          },
          {
            text: "Category",
            class: "pa-1",
            value: "other__value",
            filterable: true,
            data_type: String
          },
          {
            text: "O-Total(m)",
            class: "pa-1",
            value: "other_hour",
            filterable: true,
            data_type: Number
          },
          {
            text: "Remark",
            class: "pa-1",
            value: "remark",
            filterable: true,
            data_type: String
          },
          {
            text: "Status",
            class: "pa-1",
            value: "status__value",
            filterable: true,
            data_type: String
          },
          {
            text: "",
            value: "a_actions",
            class: "pa-1",
            filterable: false,
            data_type: Number
          }
        ],
        records: [],
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 20,
          sortBy: "id",
          totalItems: 0
        }
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refresh_table();
      },
      deep: true
    }
  },
  async mounted() {
    this.dialog.other_categories = await common.App.getGeneralOptions(
      "Attendance",
      "other",
      ["id", "value"]
    );
  },
  methods: {
    async refresh_table() {
      this.table_setting.loading = true;
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = [
        "id",
        "emp__full_name",
        "date",
        "time_on",
        "time_off",
        "time_lunch_in",
        "time_lunch_out",
        "actual",
        "lateness",
        "early",
        "lunch_lateness",
        "ot",
        "other_id",
        "other__value",
        "other_hour",
        "status_id",
        "status__value",
        "previous_data",
        "remark"
      ];

      //   var rule = new qb.Rule();

      //   rule
      //     .field("dept_id")
      //     .operator(qb.NUM_OPERATOR.EQUAL)
      //     .value(dept_id);

      cls_qb.Where = this.new_filter;

      //   cls_qb.Where = {
      //     condition: "and",
      //     rules: [
      //       {
      //         field: "date",
      //         operator: "__gt",
      //         value: "2019-09-03"
      //       },
      //       {
      //         condition: "or",
      //         rules: [
      //           {
      //             field: "lunch_lateness",
      //             operator: "__gte",
      //             value: "0"
      //           },
      //           {
      //             field: "early",
      //             operator: "__gte",
      //             value: "0"
      //           }
      //         ]
      //       }
      //     ]
      //   };

      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData(
        "attendance_report/listing_hod/",
        cls_qb
      );

      if (result.data.Status == 1) {
        this.table_setting.records = result.data.Body.records;

        this.table_setting.pagination.totalItems =
          result.data.Body.total_records_after_filtered;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }

      this.table_setting.loading = false;
    },
    get_date_day(date) {
      return day_setting[new Date(date).getDay()];
    },
    get_actual(epoch) {
      var return_value = "-";

      if (epoch) {
        return_value = (epoch / 60).toFixed(0);
      }
      return return_value;
    },
    get_epoch_minutes(epoch) {
      var return_value = "-";

      if (epoch) {
        return_value = (epoch / 60).toFixed(0);
      }
      return return_value;
    },
    get_epoch_time_v2(rec, attr_name) {
      var return_value = "";
      var previous_value = rec["previous_data"][attr_name];
      var current_value = rec[attr_name];

      if (current_value) {
        return_value = new Date(current_value * 1000)
          .toTimeString()
          .split(" ")[0];
      }

      if (current_value != previous_value) {
        return_value = `<${return_value}>`;
      }
      return return_value;
    },
    get_epoch_time(epoch) {
      var return_value = "";

      if (epoch) {
        return_value = new Date(epoch * 1000).toTimeString().split(" ")[0];
      }

      return return_value;
    },
    edit_attendance_rec(rec) {
      this.dialog.show = true;
      this.dialog.selected = Object.assign({}, rec);
    },
    update_epoch(title, ref_name) {
      this.dialog.time_dialog.show = true;
      this.dialog.time_dialog.title = title;
      this.dialog.time_dialog.ref_name = ref_name;

      this.dialog.time_dialog.time = this.get_epoch_time(
        this.dialog.selected[ref_name]
      );
    },
    confirm_update_epoch() {
      var str_datetime =
        this.dialog.selected.date + " " + this.dialog.time_dialog.time;

      this.dialog.selected[
        this.dialog.time_dialog.ref_name
      ] = common.App.get_str_datetime2epoch(str_datetime);
      this.dialog.time_dialog.show = false;
    },
    copy_table() {
      var el = document.getElementsByClassName("v-datatable")[0];
      var range = document.createRange();

      var body = document.body,
        sel;
      if (document.createRange && window.getSelection) {
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
      }
      document.execCommand("Copy");
      sel.removeAllRanges();
    },
    async save_attendance_rec() {
      let self = this;

      var data_to_be_save = {
        id: self.dialog.selected.id,
        time_lunch_in: self.dialog.selected.time_lunch_in,
        time_lunch_out: self.dialog.selected.time_lunch_out,
        time_off: self.dialog.selected.time_off,
        time_on: self.dialog.selected.time_on,
        ot: self.dialog.selected.ot || null,
        other_id: self.dialog.selected.other_id || null,
        other_hour: self.dialog.selected.other_hour || null,
        remark: self.dialog.selected.remark
      };

      let result = await common.wBackEndComm.PutData(
        "attendance_report/crud/",
        data_to_be_save
      );

      if (result.data.Status == 1) {
        self.dialog.show = false;
        self.refresh_table();
        common.wMsgBox.Success(result.data.Description);
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    }
  }
};
</script>

<style scoped>
th, td {
	border:solid 1px black;
}

thead {
	background-color: #cecece;
}
</style>
